import { all, fork } from 'typed-redux-saga/macro';

import { initializeStatsig } from './initializeStatsig';

export function* watchAnalytics() {
  yield* all([fork(initializeStatsig)]);
}
